import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SKIP_SPINNER } from '../spinner.service';
import {
  SecurityConfig,
  SecurityConfigPatch,
  SecurityConfigPublic,
  SecurityConfigSaveResponse
} from './security-config.model';

@Injectable({
  providedIn: 'root'
})
export class SecurityConfigService {
  private readonly baseUrl = `${environment.apiUrlHost}/auth/security-config`;

  constructor(private http: HttpClient) {}

  /** Not cached: an admin can switch the mode at any time. */
  getPublicConfig(): Observable<SecurityConfigPublic> {
    return this.http.get<SecurityConfigPublic>(`${this.baseUrl}/public/`, {
      context: new HttpContext().set(SKIP_SPINNER, true),
    });
  }

  getConfig(): Observable<SecurityConfig> {
    return this.http.get<SecurityConfig>(`${this.baseUrl}/`);
  }

  updateConfig(patch: SecurityConfigPatch): Observable<SecurityConfigSaveResponse> {
    return this.http.patch<SecurityConfigSaveResponse>(`${this.baseUrl}/`, patch);
  }
}
